// Толпа зевак у подножия стройки: один InstancedMesh человечков + один
// шапок = 2 draw call на всё. Каждые 10 этажей прибывает +4 зрителя, на
// победе толпа прыгает и подбрасывает шапки. Скейлер качества может срезать
// толпу множителем вплоть до нуля — эффект деградирует изящно.
import * as THREE from 'three';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';

const MAX = 24;

// Цвета одежды: приглушённая уличная палитра + пара фирменных красных
const SHIRT = [0xc46a4f, 0x5a7d9a, 0x7d8a5c, 0xb08c5a, 0xe2231a, 0x8a6aa0, 0x4f4f55, 0xd9c8a9];

export function createCrowd(scene) {
  // Человечек: тело-параллелепипед + голова, слиты в одну геометрию
  const body = new THREE.BoxGeometry(0.42, 0.78, 0.28);
  body.translate(0, 0.39, 0);
  const head = new THREE.BoxGeometry(0.26, 0.26, 0.24);
  head.translate(0, 0.95, 0);
  const person = mergeGeometries([body, head]);

  const mat = new THREE.MeshLambertMaterial();
  const mesh = new THREE.InstancedMesh(person, mat, MAX);
  mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
  // Боундинг InstancedMesh считается по геометрии в origin, а инстансы
  // разбросаны на ±9 м — без этого флага толпу срезает фрустум-куллинг
  mesh.frustumCulled = false;
  mesh.castShadow = true;
  mesh.count = 0;
  scene.add(mesh);

  // Шапки: маленькие плоские боксы, на победе летят вверх
  const capGeom = new THREE.BoxGeometry(0.3, 0.09, 0.3);
  const capMesh = new THREE.InstancedMesh(capGeom, new THREE.MeshLambertMaterial(), MAX);
  capMesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
  capMesh.frustumCulled = false;
  capMesh.count = 0;
  scene.add(capMesh);

  // Места: полукруг перед зданием, ближе к камере, мимо зоны падения блоков
  const spots = [];
  for (let i = 0; i < MAX; i++) {
    const side = i % 2 === 0 ? 1 : -1;
    const r = 5.2 + (i % 5) * 0.85;
    const a = 0.25 + ((i * 0.37) % 1) * 0.9;
    spots.push({
      x: side * Math.cos(a) * r,
      z: 2.2 + Math.sin(a) * 2.6,
      phase: (i * 1.7) % (Math.PI * 2),
      color: new THREE.Color(SHIRT[i % SHIRT.length]),
      capVy: 0, capY: 0,
    });
  }

  const M = new THREE.Matrix4();
  const Q = new THREE.Quaternion();
  const S = new THREE.Vector3(1, 1, 1);
  const P = new THREE.Vector3();

  let target = 0;      // сколько зевак хочет игра
  let scale = 1;       // множитель скейлера качества (0 — толпы нет)
  let visible = 0;
  let celebrating = false;

  function applyColors() {
    for (let i = 0; i < visible; i++) {
      mesh.setColorAt(i, spots[i].color);
      capMesh.setColorAt(i, spots[i].color);
    }
    if (mesh.instanceColor) mesh.instanceColor.needsUpdate = true;
    if (capMesh.instanceColor) capMesh.instanceColor.needsUpdate = true;
  }

  function refreshCount() {
    visible = Math.min(MAX, Math.round(target * scale));
    mesh.count = visible;
    capMesh.count = celebrating ? visible : 0;
    applyColors();
  }

  return {
    // Базовая толпа уровня; каждые 10 этажей game зовёт add()
    setCount(n) { target = Math.max(0, Math.min(MAX, n)); refreshCount(); },
    add(n) { this.setCount(target + n); },
    // Множитель от скейлера качества (1 / 0.5 / 0)
    setScale(s) { if (s !== scale) { scale = s; refreshCount(); } },
    celebrate(on) {
      celebrating = on;
      for (const s of spots) { s.capVy = 3 + Math.random() * 2; s.capY = 1.05; }
      refreshCount();
    },

    update(dt, elapsed) {
      if (!visible) return;
      for (let i = 0; i < visible; i++) {
        const s = spots[i];
        // Обычный режим — лёгкое переминание; победа — прыжки волной
        const hop = celebrating
          ? Math.abs(Math.sin(elapsed * 5 + s.phase)) * 0.55
          : Math.sin(elapsed * 1.6 + s.phase) * 0.03;
        P.set(s.x, hop, s.z);
        Q.setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.atan2(-s.x, -s.z));
        M.compose(P, Q, S);
        mesh.setMatrixAt(i, M);

        if (celebrating) {
          // Шапка летит вверх, падает и ловится на уровне головы
          s.capVy -= 9 * dt;
          s.capY += s.capVy * dt;
          if (s.capY < 1.05) { s.capY = 1.05; s.capVy = 2.2 + Math.random() * 2.5; }
          P.set(s.x, s.capY, s.z);
          M.compose(P, Q, S);
          capMesh.setMatrixAt(i, M);
        }
      }
      mesh.instanceMatrix.needsUpdate = true;
      if (celebrating) capMesh.instanceMatrix.needsUpdate = true;
    },
  };
}
